<template>
  <div class="pages">
    <navTop></navTop>
    <!-- 标题 -->
    <div class="title">
      <span>{{ details.serveTitle }}</span>
    </div>
    <div class="box">
      <!-- 信息 -->
      <div class="information">
        <div class="information-item item1">
          <p class="item-title">
            <span></span>
            <span>Mr.{{ details.name.substr(0, 1) }}</span>
            <span>Free</span>
          </p>
          <ul>
            <li>
              <span>Service Fee:</span>
              <span>${{ details.price }}</span>
            </li>
            <li>
              <span>Order Serviced:</span>
              <span>{{ details.counts || 0 }}</span>
            </li>
            <li>
              <span>Service Scope:</span>
              <span v-if="details.serveType == 0">Pre-loading / Discharging
                Survey</span>
              <span v-if="details.serveType == 1">On/Off Hire Bunker
                Survey/Bunker & Condition Survey</span>
              <span v-if="details.serveType == 2">Bunkering Survey</span>
              <span v-if="details.serveType == 3">Draft Survey</span>
              <span v-if="details.serveType == 4">Insurance Adjust Survey</span>
            </li>
            <li>
              <span>Service Year(s):</span>
              <span>{{ details.workYear }}Year</span>
            </li>
          </ul>
        </div>
        <div class="information-item item1">
          <p class="item-title">
            <span></span>
            <span>Order information</span>
            <span @click="show = true">Modify</span>
          </p>
          <ul>
            <li>
              <span>Customer's Full Name:</span>
              <span>{{ details.username }}</span>
            </li>
            <li>
              <span>Cell-phone No.:</span>
              <span>{{ details.phone }}</span>
            </li>
            <li>
              <span>Code of Company:</span>
              <span>{{ details.company }}</span>
            </li>
            <li>
              <span>Company's Address:</span>
              <span>{{ details.address }}</span>
            </li>
          </ul>
        </div>
        <div class="information-item item2">
          <p class="item-title">
            <span></span>
            <span>Detailed information</span>
            <span></span>
          </p>
          <textarea placeholder="Please enter details"
            v-model="information"></textarea>
        </div>
        <div class="information-item item2">
          <p class="item-title">
            <span></span>
            <span>Remarks</span>
            <span></span>
          </p>
          <textarea placeholder="Please enter comments"
            v-model="remarks"></textarea>
        </div>
      </div>
      <!-- 他的日期 -->
      <div class="hisDate">
        <p class="hisDate-title">Surveyor's Calendar</p>
        <calendar :gzList="details.dateWorkArg" :xxList="details.dateRestArg"
          :yxList="details.workDate" @val="fnVal"></calendar>
      </div>
      <!-- 具体开始时间 -->
      <div class="time">
        <span>Time & Date of Survey</span>
        <el-date-picker v-model="time" type="datetime" :editable="false"
          :format="'yyyy-MM-dd HH:mm:ss'" :clearable="false"
          placeholder="Select time" :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <!-- 服务城市 -->
      <div class="bx">
        <span>Name of Place to be Serviced</span>
        <select @change="selectService($event)">
          <option v-for="item in details.workArea.split(',')">
            {{ item }}
          </option>
        </select>
        <span>Kind of Business</span>
        <select @change="fnOne($event)">
          <option v-for="(item, index) in bxList" :key="index">
            {{ item.name }}
          </option>
        </select>
        <span>Kind of Claims</span>
        <select @change="fnTwo($event)">
          <option v-for="(item, index) in TwoList" :key="index">
            {{ item.name }}
          </option>
        </select>
        <!-- <select @change="fnThree($event)">
					<option v-for="(item, index) in ThreeList" :key="index">
						{{ item.name }}
					</option>
				</select> -->
      </div>
      <!-- 案件名称 -->
      <div class="case">
        <span>Subject</span>
        <textarea v-model="caseName"
          placeholder="Please fill in the subject of case…"></textarea>
      </div>
      <!-- 案件背景 -->
      <div class="case">
        <span>The Background</span>
        <textarea v-model="caseBackground"
          placeholder="Please fill in the background of case…"></textarea>
      </div>

      <!-- 查勘地址 -->
      <div class="case">
        <span>Full Address of Survey</span>
        <textarea v-model="caseAddress"
          placeholder="Please fill in the full address of survey…"></textarea>
      </div>
      <!-- 具体要求 -->
      <div class="case">
        <span>Requirements</span>
        <textarea v-model="caseRequire"
          placeholder="Please fill in the survey requirements…"></textarea>
      </div>
      <!-- 是否需要携带特殊工具 -->
      <div class="tool">
        <div class="tool-top">
          <span>Special Tools Needed or Not</span>
          <el-switch v-model="isSwitch" active-color="#00d9dd"
            inactive-color="#ff4949" @change="change"></el-switch>
        </div>
        <textarea v-model="toolsName" :disabled="disabled"
          placeholder="Such as thermometer, silver nitrate solution,tape,etc"></textarea>
      </div>
      <!-- 报告模板及附件 -->
      <div class="enclosure">
        <span>Report template and attachments</span>
        <el-upload class="upload-demo" :action="imageUrl"
          :on-remove="handleRemove" :on-success="onSuccess" multiple
          :file-list="fileList">
          <i class="el-icon-upload"></i>
        </el-upload>
      </div>
      <!-- 图片 -->
      <div class="enclosure">
        <span>Picture</span>
        <el-upload :action="imageUrl" list-type="picture-card"
          :on-success="onSuccess2" :on-remove="handleRemove2">
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <!-- 立即下单 -->
      <div class="ordernow" @click="goPay">Order now</div>
    </div>
    <navFooter></navFooter>
    <!-- 修改框 -->
    <el-dialog :visible.sync="show" :width="'460px'" :show-close="false"
      :close-on-click-modal="false">
      <div class="dialog-title">Personal information</div>
      <li class="dialog-li">
        <input type="text" v-model="details.username"
          placeholder="Please enter your name" />
        <img v-if="details.username.length > 0" @click="details.username = ''"
          src="../../assets/del.png" alt="" />
      </li>
      <li class="dialog-li">
        <input type="text" v-model="details.company"
          placeholder="Please enter your company" />
        <img v-if="details.company.length > 0" @click="details.company = ''"
          src="../../assets/del.png" alt="" />
      </li>
      <li class="dialog-li">
        <input type="text" v-model="details.address"
          placeholder="Please enter your address" />
        <img v-if="details.address.length > 0" @click="details.address = ''"
          src="../../assets/del.png" alt="" />
      </li>
      <li class="dialog-li">
        <input type="text"
          @input="details.phone = details.phone.replace(/[^\d]/g, '')"
          maxlength="11" v-model="details.phone"
          placeholder="Please enter your mobile phone number" />
        <img v-if="details.phone.length > 0" @click="details.phone = ''"
          src="../../assets/del.png" alt="" />
      </li>
      <div class="dialog-btn" @click="edit">Preservation</div>
    </el-dialog>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
import calendar from '../../components/calendar.vue';
export default {
  name: 'placeOrder',
  components: {
    navTop,
    navFooter,
    calendar
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now();
        },
        shortcuts: [
          {
            text: '今天',
            onClick (picker) {
              picker.$emit('pick', new Date());
            }
          },
          {
            text: '明天',
            onClick (picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },
          {
            text: '一周后',
            onClick (picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }
        ]
      },
      details: {}, //下单数据
      show: false, //修改框状态
      information: '', //详细信息
      remarks: '', //备注
      calendarList: [],
      service: '',
      time: '',
      bxList: [
        {
          name: 'Marine insurance',
          secondLevel: [
            { name: 'Cargo Claims (with onsite survey)' },
            { name: 'Cargo Claims (Without onsite survey)' },
            { name: 'Salvage/ScrapValue Realizing' },
            { name: 'Recovery Service' },
            { name: 'Risk Accessment or Warehouse Risk Survey' },
            { name: 'Supervision for Destroy' },
            { name: 'Accident Investigation' },
            { name: 'Other Marine Cases.' },







            // {
            // 	name: 'Marine Insurance',
            // 	// Tertiary: [
            // 	// 	{ name: 'Cargo Claims (with onsite survey)' },
            // 	// 	{ name: 'Cargo Claims (Without onsite survey)' },
            // 	// 	{ name: 'Salvage/ScrapValue Realizing' },
            // 	// 	{ name: 'Recovery Service' },
            // 	// 	{ name: 'Risk Accessment or Warehouse Risk Survey' },
            // 	// 	{ name: 'Supervision for Destroy' },
            // 	// 	{ name: 'Accident Investigation' },
            // 	// 	{ name: 'Other Marine Cases' },
            // 	// 	// { name: 'Marine insurance others' }
            // 	// ]
            // },
            // {
            // 	name: 'Notarization and authentication',
            // 	// Tertiary: [
            // 	// 	{ name: 'Loading and unloading supervision' },
            // 	// 	{ name: 'Weight identification' },
            // 	// 	{ name: 'Cargo load measurement (ruler)' },
            // 	// 	{ name: 'quality restriction' },
            // 	// 	{ name: 'Sampling test' },
            // 	// 	{ name: 'Construction Supervision' },
            // 	// 	{ name: 'Other notarial authentication' }
            // 	// ]
            // },
            // {
            // 	name: 'Overseas claims agent',
            // 	// Tertiary: [{ name: 'Overseas claims agent' }]
            // }
          ]
        },
        {
          name: 'Non marine insurance',
          secondLevel: [
            { name: 'Enterprise Property Insurance' },
            { name: 'Family Property Insurance' },
            { name: 'Projects Insurance' },
            { name: 'Import/Export Credit Insurance' },
            { name: 'Consultation and others' },
            // 1. ;2.;3. ;4. 5.
            // {
            // 	name: 'Property insurance adjustment',
            // 	Tertiary: [
            // 		{ name: 'Basic insurance' },
            // 		{ name: 'Comprehensive insurance' },
            // 		{ name: 'All risks' },
            // 		{ name: 'Machine damage insurance' },
            // 		{ name: 'Interest loss insurance' },
            // 		{ name: 'Family property insurance' },
            // 		{ name: 'other' },
            // 		{ name: 'Construction machinery' }
            // 	]
            // },
            // {
            // 	name: 'Liability insurance adjustment',
            // 	Tertiary: [
            // 		{ name: 'Property management liability insurance' },
            // 		{ name: 'Public liability insurance' },
            // 		{ name: 'Product liability insurance' },
            // 		{ name: 'Construction engineering design liability insurance' },
            // 		{ name: 'Employers liability insurance' },
            // 		{ name: 'other' },
            // 		{ name: 'Liability insurance adjustment level II' }
            // 	]
            // },
            // {
            // 	name: 'risk assessment',
            // 	Tertiary: [
            // 		{ name: 'Chemical enterprise' },
            // 		{ name: 'Energy enterprise' },
            // 		{ name: 'Water Conservancy Environment' },
            // 		{ name: 'manufacturing enterprise' },
            // 		{ name: 'Logistics enterprise' },
            // 		{ name: 'Wholesale and retail' },
            // 		{ name: 'Financial services' },
            // 		{ name: 'other' },
            // 		{ name: 'Risk assessment level II' }
            // 	]
            // },
            // {
            // 	name: 'Construction insurance adjustment',
            // 	Tertiary: [
            // 		{ name: 'Construction all risks insurance' },
            // 		{ name: 'Installation all risks insurance' },
            // 		{ name: 'Architecture' },
            // 		{ name: 'Installation works insurance' },
            // 		{ name: 'other' },
            // 		{ name: 'Level II of construction insurance adjustment' }
            // 	]
            // },
            // {
            // 	name: 'credit insurance',
            // 	Tertiary: [
            // 		{ name: 'Domestic credit insurance' },
            // 		{ name: 'Foreign credit insurance' }
            // 	]
            // }
          ]
        },
        {
          name: 'Italian health insurance',
          secondLevel: [
            { name: 'Life Insurance' },
            { name: 'Health Insurance' },
            { name: 'Accident Insurance' },
            { name: 'Liability Insurance' },
            { name: 'Mobile Liability Insurance （personal injured in the accident）' },
            { name: 'Accident Investigation' },
            { name: 'Others.' },
            // 1. ;2.; 3. ;4. ；5. ;6.; 7.
            // 	{
            // 		name: 'Health insurance',
            // 		Tertiary: [
            // 			{ name: 'Medical insurance' },
            // 			{ name: 'Serious illness insurance' },
            // 			{ name: 'Other health insurance' }
            // 		]
            // 	},
            // 	{
            // 		name: 'accident insurance',
            // 		Tertiary: [
            // 			{ name: 'Construction accident insurance' },
            // 			{ name: 'Traffic accident insurance' },
            // 			{ name: 'Travel accident insurance' },
            // 			{ name: 'Aviation accident insurance' },
            // 			{ name: 'Comprehensive accident insurance' },
            // 			{ name: 'Other accident insurance' }
            // 		]
            // 	},
            // 	{
            // 		name: 'Liability insurance',
            // 		Tertiary: [
            // 			{ name: 'Employers liability insurance' },
            // 			{ name: 'Public liability insurance (personal injury)' },
            // 			{
            // 				name:
            // 					'Property management liability insurance (personal injury)'
            // 			},
            // 			{ name: 'Other liability insurance' }
            // 		]
            // 	},
            // 	{
            // 		name: 'Vehicle insurance (personal injury)',
            // 		Tertiary: [
            // 			{ name: 'Motor vehicle compulsory insurance' },
            // 			{ name: 'Motor vehicle commercial insurance' }
            // 		]
            // 	},
            // 	{
            // 		name: 'life insurance',
            // 		Tertiary: [
            // 			{ name: 'Term life insurance' },
            // 			{ name: 'Life insurance' },
            // 			{ name: 'Universal life insurance' },
            // 			{ name: 'Other life insurance' }
            // 		]
            // 	},
            // 	{
            // 		name: 'Platform business',
            // 		Tertiary: [
            // 			{ name: 'Medical survey' },
            // 			{ name: 'Accident investigation' },
            // 			{ name: 'Other investigations' }
            // 		]
            // 	},
            // 	{
            // 		name: 'other',
            // 		Tertiary: [
            // 			{ name: 'Medical escort' },
            // 			{ name: 'Overseas medical treatment' },
            // 			{ name: 'Health management' },
            // 			{ name: 'other' }
            // 		]
            // 	}
          ]
        },
        {
          name: 'Hull Claims',
          secondLevel: [
            {
              name: 'Hull Claims & Accident Investigation.',
              // Tertiary: [
              // 	{ name: 'Hull Claims & Accident Investigation' },

              // ]
            },

          ]
        },
        {
          name: 'Others',
          secondLevel: [
            {
              name: 'Others',
              // Tertiary: [
              // 	{ name: 'Others' },

              // ]
            },

          ]
        }
      ],
      TwoList: [],
      ThreeList: [],
      oneName: '',
      twoName: '',
      threeName: '',
      caseBackground: '', //案件背景
      caseName: '', //案件名
      caseAddress: '', //查勘地址
      caseRequire: '', //具体要求
      isSwitch: false,
      disabled: true,
      toolsName: '',
      fileList: [],
      file: [],
      imgList: []
    };
  },
  created () {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({ path: '/' });
    } else {
      let obj = JSON.parse(this.$route.query.obj);
      this.details = {
        docId: obj.docId,
        serveId: obj.serveId,
        serveTitle: obj.serveTitle,
        name: obj.name,
        price: obj.price,
        serveType: obj.serveType,
        counts: obj.counts,
        workYear: obj.workYear,
        workDate: JSON.parse(obj.workDate),
        workArea: obj.workArea,
        username: JSON.parse(sessionStorage.getItem('infoList')).name,
        phone: JSON.parse(sessionStorage.getItem('infoList')).phone,
        company: JSON.parse(sessionStorage.getItem('infoList')).company,
        address: JSON.parse(sessionStorage.getItem('infoList')).address,
        dateWorkArg: obj.dateWorkArg,
        dateRestArg: obj.dateRestArg,
        servePic: obj.servePic,
        appraiseStar: obj.appraiseStar
      };
      this.service = obj.workArea.split(',')[0];
      this.TwoList = this.bxList[0].secondLevel;
      this.ThreeList = this.TwoList[0].Tertiary;
      this.oneName = this.bxList[0].name;
      this.twoName = this.TwoList[0].name;
      // this.threeName = this.ThreeList[0].name;
    }
  },
  methods: {
    edit () {
      if (this.details.username == '') {
        this.details.username = JSON.parse(
          sessionStorage.getItem('infoList')
        ).name;
      }
      if (this.details.phone == '') {
        this.details.phone = JSON.parse(
          sessionStorage.getItem('infoList')
        ).phone;
      }
      if (this.details.company == '') {
        this.details.company = JSON.parse(
          sessionStorage.getItem('infoList')
        ).company;
      }
      if (this.details.address == '') {
        this.details.address = JSON.parse(
          sessionStorage.getItem('infoList')
        ).address;
      }
      this.show = false;
    },
    // 接收选择日期
    fnVal (val) {
      this.calendarList = val;
    },
    // 选择服务
    selectService (e) {
      this.service = e.target.value;
    },
    // 一级
    fnOne (e) {
      let i = e.target.options.selectedIndex;
      this.TwoList = this.bxList[i].secondLevel;
      this.oneName = event.target.value;
      this.twoName = this.TwoList[0].name;
      // this.threeName = this.ThreeList[0].name;
    },
    // 二级
    fnTwo (e) {
      let i = e.target.options.selectedIndex;
      // this.ThreeList = this.TwoList[i].Tertiary;
      this.twoName = event.target.value;
      // this.threeName = this.ThreeList[0].name;
    },
    // 三级
    // fnThree(e) {
    // 	this.threeName = event.target.value;
    // },
    // 是否携带工具
    change (e) {
      if (e) {
        this.disabled = false;
      } else {
        this.toolsName = '';
        this.disabled = true;
      }
    },
    // 上传文件成功
    onSuccess (res, file) {
      this.file.push(res.url);
    },
    // 删除文件
    handleRemove (file, fileList) {
      this.file = [];
      fileList.forEach(item => {
        this.file.push(item.response.url);
      });
    },
    // 上传图片成功
    onSuccess2 (res, file) {
      this.imgList.push(res.url);
    },
    // 删除图片
    handleRemove2 (file, fileList) {
      this.imgList = [];
      fileList.forEach(item => {
        this.imgList.push(item.response.url);
      });
    },
    // 转化时间
    formatDateTime (date) {
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      let minute = date.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      let second = date.getSeconds();
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
    // 立即下单
    goPay () {
      if (this.information == '') {
        this.$message({
          message: 'Details cannot be empty',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.time == '') {
        this.$message({
          message: 'Please select a specific start time',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      let workDate = [];
      this.calendarList.forEach(item => {
        workDate.push(item.day);
      });
      let withTools = '';
      if (this.isSwitch) {
        withTools = 1;
      } else {
        withTools = 0;
      }
      let servePic;
      if (this.details.servePic instanceof Array) {
        servePic = this.details.servePic.join("|")
      } else {
        servePic = this.details.servePic
      }
      let data = {
        uid: sessionStorage.getItem('uid'),
        docId: this.details.docId,
        serveId: this.details.serveId,
        serveType: this.details.serveType,
        workDate: workDate.join(','),
        startTime: this.formatDateTime(this.time),
        name: this.details.username,
        phone: this.details.phone,
        company: this.details.company,
        address: this.details.address,
        city: this.service,
        detail: this.information,
        remarks: this.remarks,
        type: this.oneName + '-' + this.twoName + '-' + '',
        caseBackground: this.caseBackground,
        caseName: this.caseName,
        caseAddress: this.caseAddress,
        caseRequire: this.caseRequire,
        withTools: withTools,
        toolsName: this.toolsName,
        reportTemplate: this.file.join('|'),
        picture: this.imgList.join('|'),
        price: workDate.length * this.details.price,
        servePic: servePic,
        appraiseStar: this.details.appraiseStar
      };
      console.log(data, 'datadatadata')
      // return false
      this.$api.create(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.$router.push({
            path: '/pay',
            query: {
              id: res.data.orderId,
              sum: res.data.sum,
              title: this.details.serveTitle,
              serveType: 4,
              num: 1
            }
          });
        } else {
          this.$message({
            message: res.resultNote,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pages {
  background: #000;
  .box {
    // 信息
    .information {
      margin-top: 36px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      .information-item {
        width: 695px;
        background-image: url(../../assets/details-items.png);
        background-size: 100% 100%;
        border-radius: 21px;
        margin-bottom: 55px;
        .item-title {
          padding: 30px 51px 0 37px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span:nth-child(1) {
            display: block;
            width: 70px;
          }
          span:nth-child(2) {
            font-size: 33px;
            color: #00fff0;
            line-height: 1em;
          }
          span:nth-child(3) {
            display: block;
            width: 70px;
            text-align: center;
            font-size: 22px;
            color: #1bf6ff;
            line-height: 1em;
          }
        }
      }
      .item1 {
        padding: 0px 40px 60px 53px;
        box-sizing: border-box;
        ul {
          padding: 41px 30px 0 30px;
          box-sizing: border-box;
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 19px;
            span:nth-child(1) {
              font-size: 27px;
              color: #e3fffd;
              line-height: 1em;
              margin-right: 34px;
            }
            span:nth-child(2) {
              flex: 1;
              display: inline-block;
              font-size: 27px;
              color: #00fff0;
              line-height: 1em;
              text-align: right;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .item2 {
        padding: 0 40px 60px 53px;
        box-sizing: border-box;
        height: 362px;
        .text {
          padding: 35px 43px 0 33px;
          box-sizing: border-box;
          font-size: 26px;
          color: #e3fffd;
          line-height: 36px;
        }
        textarea {
          width: 100%;
          height: 211px;
          background: rgba(35, 254, 246, 0.1);
          border: 1px solid #48ece7;
          outline: none;
          resize: none;
          padding: 17px 20px;
          box-sizing: border-box;
          font-weight: 400;
          font-size: 18px;
          color: #13fffc;
          line-height: 28px;
          margin-top: 35px;
        }
        textarea::-webkit-input-placeholder {
          color: #13fffc;
        }
      }
      .information-item:nth-child(2n) {
        margin-right: 0;
      }
    }
    // 他的日期
    .hisDate {
      width: 100%;
      border-radius: 45px;
      background-image: url(../../assets/details-case.png);
      background-size: 100% 100%;
      padding: 0 87px 100px 114px;
      box-sizing: border-box;
      .hisDate-title {
        text-align: center;
        color: #ffffff;
        padding: 100px 0;
        box-sizing: border-box;
        font-size: 60px;
      }
    }
    // 时间
    .time {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 30px;
      span {
        color: #00d9dd;
        font-size: 26px;
        line-height: 1em;
        margin-bottom: 20px;
      }
      ::v-deep .el-input {
        width: 100%;
        .el-input__inner {
          height: 70px;
          background: #000;
          padding: 0 20px;
          box-sizing: border-box;
          border: 1px solid #48ece7;
          color: #00d9dd;
          font-size: 26px;
          background: #002f35;
        }
        .el-input__prefix {
          display: none;
        }
        .el-input__suffix {
          display: none;
        }
        input::-webkit-input-placeholder {
          color: rgba(19, 255, 252, 1);
        }
        input:-moz-placeholder {
          color: rgba(19, 255, 252, 1);
        }
        input::-moz-placeholder {
          color: rgba(19, 255, 252, 1);
        }
        input::-ms-input-placeholder {
          color: rgba(19, 255, 252, 1);
        }
      }
    }
    .bx {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 10px;
      span {
        color: #00d9dd;
        font-size: 26px;
        line-height: 1em;
        margin-bottom: 20px;
      }
      // 下拉框
      select {
        width: 100%;
        height: 70px;
        border: 1px solid rgba(0, 250, 255, 0.6);
        border-radius: 10px;
        outline: none;
        background: #002f35;
        padding: 0 20px;
        box-sizing: border-box;
        font-size: 26px;
        color: #00fff0;
        margin-bottom: 15px;
        option {
          background: #000;
          color: #00d9dd;
        }
      }
    }
    .case {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      span {
        color: #00d9dd;
        font-size: 26px;
        line-height: 1em;
        margin-bottom: 20px;
      }
      textarea {
        height: 150px;
        background: #002f35;
        border: 1px solid #48ece7;
        outline: none;
        resize: none;
        padding: 17px 20px;
        box-sizing: border-box;
        font-weight: 400;
        color: #13fffc;
        line-height: 28px;
        border-radius: 10px;
        font-size: 18px;
      }
      textarea::-webkit-input-placeholder {
        color: #13fffc;
      }
    }
    .tool {
      display: flex;
      flex-direction: column;
      .tool-top {
        display: flex;
        align-items: center;
        span {
          color: #00d9dd;
          font-size: 26px;
          line-height: 1em;
          margin-right: 20px;
        }
      }
      textarea {
        height: 150px;
        background: #002f35;
        border: 1px solid #48ece7;
        outline: none;
        resize: none;
        padding: 17px 20px;
        box-sizing: border-box;
        font-weight: 400;
        color: #13fffc;
        line-height: 28px;
        border-radius: 10px;
        font-size: 18px;
        margin-top: 20px;
      }
      textarea::-webkit-input-placeholder {
        color: #13fffc;
      }
    }
    .enclosure {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      span {
        color: #00d9dd;
        font-size: 26px;
        line-height: 1em;
        margin-bottom: 20px;
      }
      .upload-demo {
        ::v-deep .el-upload {
          width: 100px;
          height: 100px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #48ece7;
          background: #002f35;
          box-sizing: border-box;
          .el-icon-upload {
            font-size: 50px;
            color: #ffffff;
          }
        }
        ::v-deep .el-upload-list {
          background: #ffffff;
        }
      }
    }
    // 立即下单
    .ordernow {
      width: 728px;
      height: 104px;
      background: linear-gradient(
        90deg,
        rgba(29, 175, 170, 0.8) 0%,
        rgba(35, 254, 246, 0.8) 100%
      );
      margin: 61px auto;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #f6f6f6;
      line-height: 104px;
      text-align: center;
    }
  }
  .title {
    width: 100%;
    height: 131px;
    background-image: url(../../assets/details-title.png);
    background-size: 100% 100%;
    margin-top: 50px;
    span {
      width: 100%;
      height: 87px;
      display: block;
      text-align: center;
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #00fcff;
      line-height: 87px;
      padding-right: 70px;
      box-sizing: border-box;
    }
  }
}
::v-deep .el-dialog__wrapper {
  .el-dialog {
    height: 577px;
    background-image: url(../../assets/place-order-edit.png);
    background-size: 100% 100%;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 31px 42px 80px 38px;
      box-sizing: border-box;
      .dialog-title {
        font-size: 30px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #06fffd;
        text-align: center;
        line-height: 1em;
        margin-bottom: 5px;
      }
      .dialog-li {
        height: 71px;
        border-bottom: 1px solid #06fffd;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        input {
          width: 100%;
          height: 69px;
          background: #060c18;
          border: none;
          font-size: 14px;
          outline: none;
          color: #13fffc;
          padding: 0 6px;
          box-sizing: border-box;
        }
        img {
          width: 16px;
          height: 16px;
          display: block;
        }
      }
      .dialog-btn {
        width: 100%;
        height: 60px;
        background: linear-gradient(
          90deg,
          rgba(26, 175, 170, 0.8) 0%,
          rgba(29, 255, 247, 0.8) 100%
        );
        margin-top: 83px;
        font-size: 24px;
        font-weight: bold;
        color: #f6f6f6;
        line-height: 60px;
        text-align: center;
      }
    }
  }
}
</style>
